import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { downloadAllocated_FWPDF } from "./DownloadAllocatedFW_PDF";

const Rpt_FeeWaiverListing = () => {

  const [selectedYear1, setSelectedYear1] = useState();
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);

  const [selectedFW_Id, setSelectedFW_Id] = useState();
  const [ddlWaivers, setDdlWaivers] = useState([]);

  const [selectedFW_Catg, setSelectedFW_Catg] = useState();
  const [ddlCategories, setDdlCategories] = useState([]);

  const [reportData, setReportData] = useState([]);

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const WaiversResult = await axios.get(`${BASE_URL}/api/ddl_fees_waivers`);
      setDdlWaivers(WaiversResult.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);


    } catch (err) {
      console.error(err);
    }

  };

  // Fetch report
  const handleRunReport = async () => {

    if (!selectedYear1 || selectedYear1 === '') {
      toast.error('Please select Academic Year');
      return;
    }

    try {

      setReportData([]);

      const res = await axios.get(`${BASE_URL}/api/rpt_allocated_fw`, 
        {params :{p_year1: selectedYear1, p_fw_id: selectedFW_Id, p_catg: selectedFW_Catg}});

      if (res.data.length > 0) {
        setReportData(groupData(res.data));
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }

    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }

  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  /// Grouping Data on mst_fee_waivers
  const groupData = (data) => {

    const grouped = {};

    data.forEach((item) => {

      const key =
        item.fw_desc + "|" +
        item.fw_catg + "|" +
        item.bgt_name + "|" +
        item.sub_bgt_name;

      if (!grouped[key]) {
        grouped[key] = {
          fw_desc: item.fw_desc,
          fw_catg: item.fw_catg,
          bgt_name: item.bgt_name,
          sub_bgt_name: item.sub_bgt_name,
          //total_waiver_amt: 0,
          // Separate totals
          total_assigned: 0,
          total_approved: 0,
          details: []
        };
      }

      grouped[key].details.push({
        gr_no: item.gr_no,
        stud_name: item.stud_name,
        std_div: item.std_div,
        fw_remarks: item.fw_remarks,
        fw_status: item.fw_status,
        waiver_allocated_amt: item.waiver_allocated_amt,
        appr_by: item.appr_by
      });

      // Calculate status-wise totals
      const amount = Number(item.waiver_allocated_amt || 0);

      if (item.fw_status === "Assigned") {
        grouped[key].total_assigned += amount;
      }

      if (item.fw_status === "Approved") {
        grouped[key].total_approved += amount;
      }

    });

    return Object.values(grouped);

  };

  ///// Start : PDF Download

  const handleDownloadPDF = () => {

    if (reportData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    downloadAllocated_FWPDF({
        reportData,
        selectedYear1
    });

  };

  //// End Pdf download

  const formatAmount = (amount) =>

    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const getRowColor = (status) => {

    switch (status) {

      case "Approved":
        return "#a9dfbf";   // Light Green

      case "Assigned":
        return "#fff3cd";   // Light Gray

      default:
        return "#f8d7da";   // Light Red
    }

  };

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">

        <Row>

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>Fee Waiver
              </InputGroup.Text>
              <select
                className="form-select"
                name="selectedFW_Id"
                value={selectedFW_Id}
                onChange={(e) => setSelectedFW_Id(e.target.value)}>
                <option value="">-- Select Fee Waiver Description--</option>
                {ddlWaivers.map(fd => (
                  <option key={fd.fw_id} value={fd.fw_id}>{fd.fw_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}>Category
              </InputGroup.Text>
              <select name="selectedFW_Catg" value={selectedFW_Catg}
                className='form-select'
                 onChange={(e) => setSelectedFW_Catg(e.target.value)} >
                <option value="">-- Select Category --</option>
                <option value="STAFF">Staff Child</option>
                <option value="ECOWK">Economically Weak</option>
                <option value="TCHLD">Third Child</option>
                <option value="NEBOR">Neighbour</option>
                <option value="ORPHN">Orphan</option>
                <option value="OTHER">Others</option>

              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>Academic Year
              </InputGroup.Text>
              <select className="form-select" name="selectedYear1" value={selectedYear1}
                onChange={(e) => setSelectedYear1(e.target.value)} >
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>
        </Row>

        <Row className="mt-2">

          <Col md={12} className="d-flex justify-content-end">
            <Button variant="primary" className="ms-2" disabled={reportData.length === 0} onClick={handleDownloadPDF} > Download PDF </Button>
            <Button variant="success" onClick={handleRunReport} className="ms-2"> Run Report </Button>          
          </Col>
        </Row>

      </Card>

      {/* Report Table */}

      <Card className="p-3">
        <div className="table-responsive" >

          <table className="responsive-table report-table-compact scty-custom-table-rcpt hover-table-rcpt"
            style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }} >

            <colgroup>

              <col style={{ width: "8%" }} /> 
              <col style={{ width: "25%" }} /> 
              <col style={{ width: "10%" }} /> 
              <col style={{ width: "20%" }} /> 
              <col style={{ width: "8%" }} /> 
              <col style={{ width: "10%" }} />
              <col style={{ width: "12%" }} />

            </colgroup>

            <tbody>

              {reportData.length > 0 ? (

                reportData.map((group, index) => (

                  <React.Fragment key={index}>

                    {/* GROUP HEADER */}

                    <tr style={{ backgroundColor: "#d9edf7" }}>

                      <td colSpan={7} style={{ padding: "2px" }}>

                        <Row className="mb-2 mt-1">
                          <Col md={1}><b>Fee Waiver :</b></Col>
                          <Col md={5}>{group.fw_desc}</Col>

                          <Col md={1}><b>Category :</b></Col>
                          <Col md={5}>{group.fw_catg}</Col>
                        </Row>

                        <Row>
                          <Col md={1}><b>Budget :</b></Col>
                          <Col md={5}>{group.bgt_name}</Col>

                          <Col md={1}><b>Sub Budget :</b></Col>
                          <Col md={5}>{group.sub_bgt_name}</Col>
                        </Row>

                      </td>

                    </tr>

                    {/* SUB HEADER */}

                    <tr style={{ maxHeight: '35px' }}  className="table-secondary">

                      <th style={{ textAlign: "center" }}>GR No. </th>
                      <th style={{ textAlign: "left" }}>Student Name </th>
                      <th style={{ textAlign: "left" }}>Std/Div</th>
                      <th style={{ textAlign: "left" }}>Remarks</th>
                      <th style={{ textAlign: "left" }}>Status</th>
                      <th style={{ textAlign: "right" }}>Waiver Amount</th>
                      <th style={{ textAlign: "left" }}>Approved By</th>

                    </tr>

                    {/* DETAILS */}

                    {group.details.map((d, i) => (

                      <tr key={i} style={{ backgroundColor: getRowColor(d.fw_status) }}>

                        <td style={{ textAlign: "center" }}>{d.gr_no}</td>
                        <td style={{ textAlign: "left" }}>{d.stud_name}</td>
                        <td style={{ textAlign: "left" }}>{d.std_div}</td>
                        <td style={{ textAlign: "left" }}>{d.fw_remarks}</td>
                        <td style={{ textAlign: "left" }}>{d.fw_status}</td>
                        <td style={{ textAlign: "right" }}>{formatAmount(d.waiver_allocated_amt)}</td>
                        <td style={{ textAlign: "left" }}>{d.appr_by}</td>

                      </tr>

                    ))}

                    {/* GROUP TOTAL - ASSIGNED */}

                    <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
                      <td colSpan={5} style={{ textAlign: "right", color: "#e67e22" }}> Total Assigned: </td>
                      <td style={{ textAlign: "right" }}> {formatAmount(group.total_assigned)} </td>
                      <td></td>
                    </tr>

                    {/* GROUP TOTAL - APPROVED */}

                    <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
                      <td colSpan={5} style={{ textAlign: "right", color: "#27ae60" }}> Total Approved: </td>
                      <td style={{ textAlign: "right" }}> {formatAmount(group.total_approved)} </td>
                      <td></td>
                    </tr>

                    <tr>
                      <td
                        colSpan={7}
                        style={{
                          height: "15px",
                          border: "none",
                          background: "#fff"
                        }}
                      ></td>
                    </tr>

                  </React.Fragment>

                ))

              ) : (

                <tr>
                  <td colSpan={8} className="text-center">
                    Report not generated.
                  </td>
                </tr>

              )}

            </tbody>

          </table>

        </div>
      </Card>

    </Container>
  );
};

export default Rpt_FeeWaiverListing;
